module.exports = __webpack_public_path__ + "static/media/homeIllustration.e3191248.png";